import { Typography } from "@shared/primitive-components"
import { Property } from "csstype"
import { BODY_SIZE, FONT_SIZE, REGULAR_FONT, BOLD_FONT, SEMI_BOLD_FONT, FALLBACK_FONTS } from "../const"

const makeFontCSS = (font: { NAME: string; WEIGHT: number }) => ({
  fontFamily: `${font.NAME}, ${FALLBACK_FONTS}`,
  fontWeight: font.WEIGHT,
})

export const fonts = {
  heading: {
    ...makeFontCSS(BOLD_FONT),
    textTransform: `uppercase` as Property.TextTransform,
  },
  subHeading: {
    ...makeFontCSS(SEMI_BOLD_FONT),
    textTransform: `uppercase` as Property.TextTransform,
  },
  body: makeFontCSS(REGULAR_FONT),
}

const bodyCommonTypography = {
  ...fonts.body,
  lineHeight: 1.5,
}

const typography: Typography = {
  body: {
    ...bodyCommonTypography,
    fontSize: `1em`,
    lineHeight: 1.4,
  },
  body2: {
    ...bodyCommonTypography,
    fontSize: `${FONT_SIZE.CAPTION / BODY_SIZE}em`,
    lineHeight: 1.4,
  },
  headline1: {
    ...fonts.heading,
    lineHeight: 0.9,
    fontSize: `${FONT_SIZE.TITLE / BODY_SIZE}em`,
  },
  headline2: {
    ...fonts.heading,
    lineHeight: 0.9,
    fontSize: `${FONT_SIZE.SUBTITLE / BODY_SIZE}em`,
  },
  headline3: {
    ...fonts.subHeading,
    lineHeight: 0.9,
    fontSize: `${BODY_SIZE / BODY_SIZE}em`,
  },
}

export default typography
